import { Box, Slider, SxProps, Theme, Typography } from '@mui/material';

type StepSliderProps = Readonly<{
  id: string;
  label: string;
  steps: readonly string[];
  value: number;
  onChange: (value: number) => void;
}>;

export const StepSlider = ({ id, label, steps, value, onChange }: StepSliderProps) => {
  const position = value / (steps.length - 1);

  return (
    <Box sx={containerSx}>
      <Slider
        id={id}
        aria-label={label}
        value={value}
        min={0}
        max={steps.length - 1}
        step={1}
        getAriaValueText={(step) => steps[step]}
        onChange={(_event, next) => next !== value && onChange(next as number)}
        sx={sliderSx}
      />
      <Box sx={labelRowSx} aria-hidden>
        <Typography variant="text-md-medium" sx={currentLabelSx(position)}>
          {steps[value]}
        </Typography>
      </Box>
    </Box>
  );
};

const containerSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  paddingX: backrs.spacing['spacing-lg'],
  overflowX: 'clip',
});

const sliderSx: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Colors/Background/bg-brand-solid'],
  height: backrs.spacing['spacing-md'],
  '& .MuiSlider-rail': {
    backgroundColor: backrs.colors['Colors/Border/border-secondary'],
    opacity: 1,
  },
  '& .MuiSlider-thumb': {
    width: backrs.spacing['spacing-3xl'],
    height: backrs.spacing['spacing-3xl'],
    backgroundColor: backrs.colors['Colors/Base/White'],
    border: `2px solid ${backrs.colors['Colors/Base/Black']}`,
    boxShadow: 'none',
    '&:hover, &.Mui-focusVisible, &.Mui-active': {
      boxShadow: 'none',
    },
  },
});

const labelRowSx: SxProps<Theme> = ({ typography }) => ({
  position: 'relative',
  height: typography['text-md-medium']?.lineHeight,
});

const currentLabelSx =
  (position: number): SxProps<Theme> =>
  ({ backrs }) => ({
    position: 'absolute',
    left: `${position * 100}%`,
    transform: `translateX(-${position * 100}%)`,
    whiteSpace: 'nowrap',
    color: backrs.colors['Colors/Text/text-primary'],
  });
